<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer012">
<p class="Prelims-head">About the Author</p>
<p class="Prelim-main">Desnà is a civil servant mum of three who lives in a small town in Northern Ireland. Her previously published work includes the much-loved children’s tale <span class="CharOverride-1">Little Mouse’s Big Ambition</span>.  </p>
<p class="Prelim-main">Along with her young family, Desnà has a great love for all things outdoors, and outside of writing can often be found exploring her way around the island on which she lives.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398481954_EPUB.vue?5287e7ec